module.exports = __webpack_public_path__ + "img/2.7f03dbc9.webp";